import BIForm from '../form/form';
import loadAdyenDropin from './load_adyen_dropin.js';
import AdditionalOptions from './additional_options.js';

export default function initializeStorageLocationForm() {

    const $addFormAccordion = $('#storageLocationAddFormAccordion');
    const $editFormAccordion = $('#storageLocationEditFormAccordion');
    const $manageSLAccordion = $('#manageSLAccordion');
    const $additionalOptions = new AdditionalOptions('.additionalStorageOption', loadAdyenDropin);

    const $addStorageLocationFormFields = $('#addStorageLocationForm .form-fields');
    $addStorageLocationFormFields.removeClass('d-none');
    $addStorageLocationFormFields.find('button.new-btn').removeClass('small');

    let StorageFormCreate = new BIForm({
        form_id: '#storageLocationAddFormAccordion form',
        read_url: `/account/storage-locations/read`,
    });

    $addFormAccordion.on('shown.bs.collapse', function (event) {
        $editFormAccordion.collapse('hide');
    });

    let StorageLocationEditForm = new BIForm({
        form_id: "#storageLocationEditFormAccordion form",
        read_url: `/account/storage-locations/read`,
    });

    $editFormAccordion.on('shown.bs.collapse', function (event) {
        $addFormAccordion.collapse('hide');

        let StorageLocationId = $('input[name="storageLocation"]:checked').val();

        StorageLocationEditForm.turnFormLoadingOn();

        StorageLocationEditForm.setAction("/account/storage-locations/update/" + StorageLocationId);
        StorageLocationEditForm.hideDropdown('add_lookuplist');

        StorageLocationEditForm.populateFields(StorageLocationId, (form, data) => {
            StorageLocationEditForm.turnFormLoadingOff();
        });
    });

    function setStorageLocation(id = null) {

        if (id) {
            $('input:radio[name="storageLocation"]').filter(`[value="${id}"]`).attr('checked', true);
        }

        let $selectedStorage = $('input:radio[name="storageLocation"]:checked');
        let innerText = $selectedStorage.attr('data-inner-text');
        
        $('.default-storage').html(`<li>${innerText}</li>`);

        const selectedLocationId = $selectedStorage.val();
        $('input[name="storageLocationId"]').val(selectedLocationId);

        $additionalOptions.showAdditionalOptions($selectedStorage.attr('data-country'));
    }

    function reloadStorageAddress(id = null) {

        $("body").css("cursor", "progress");

        axios.get(`/my-basket/storage-locations`).then(response => {
            $('.default_delivery-storage--options').replaceWith(response.data.html);

            setStorageLocation(id);

            $manageSLAccordion.collapse('hide');
            StorageLocationEditForm.emptyForm();
            StorageFormCreate.emptyForm();

            loadAdyenDropin();
        }).finally(() => {
            $addFormAccordion.collapse('hide');
            $editFormAccordion.collapse('hide');
            $("body").css("cursor", "default");
        });
    }

    StorageFormCreate.addSubmitListener(() => {
        reloadStorageAddress();
    });

    StorageLocationEditForm.addSubmitListener(() => {
        let id = $('input[name="storageLocation"]:checked').val();
        reloadStorageAddress(id);
    });

    $(document).on('click', '#storagelocationBtnContainer .use-selected', function () {
        setStorageLocation();

        $manageSLAccordion.collapse('hide');
        $addFormAccordion.collapse('hide');
        $editFormAccordion.collapse('hide');

        loadAdyenDropin();
    });

    function toggleEditBtnState() {
        let editDisabled = ($('input[name="storageLocation"]:checked').val() === 'bireserves');
        $('#storagelocationBtnContainer .edit-selected').toggleClass('disabled', editDisabled);
    }

    $(document).on('change', 'input[name="storageLocation"]', function () {
        StorageLocationEditForm.emptyForm();
        $editFormAccordion.collapse('hide');
        toggleEditBtnState();
    });

    // Set initial edit button state
    toggleEditBtnState();

    // Set default inbond selected storage location
    setStorageLocation();

}